module.exports = __webpack_public_path__ + "static/media/CNBC_Logo_Black.08d1a108.svg";